import { UserRole } from '@modules/core/types';
import { Permissions } from '@modules/permissions/types';

export const UHN_STAGING = {
  [UserRole.ADMINISTRATOR]: [
    Permissions.CDC_TIER1_METRICS,
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CAN_VIEW_PHI,
  ],
  [UserRole.EXECUTIVE]: [Permissions.CDC_TIER1_METRICS, Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3],
  [UserRole.MEMBER_LIMITED_PHI]: [Permissions.CDC_TIER1_METRICS, Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3],
  [UserRole.MEMBER]: [
    Permissions.CDC_TIER1_METRICS,
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CAN_VIEW_PHI,
  ],
};
